import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/org/$orgId/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/org/$orgId/overview', params, replace: true });
  },
});
